import "./App.css";
import { Quotes } from "./components/quotes/Quotes";

function App() {
    return <Quotes />;
}

export default App;
